// extracted by mini-css-extract-plugin
module.exports = {"nav":"Header_nav__2XAZr","logo":"Header_logo__3EvUy","socials":"Header_socials__15vEE","socialsContainer":"Header_socialsContainer__25QY3","navbar":"Header_navbar__3CUHR"};